// Tiny localStorage-backed session persistence so an in-progress inspection
// survives an accidental page refresh. We persist ONLY the inspectionID + the
// small form fields — the photos themselves are re-fetched from the backend by
// inspectionID on load (see usePhotoProcessor), so no image data lives here.

const KEY = 'aperture.session';

export interface SessionForm {
    user: string;
    assetCode: string;
    baselineWidth: string;
    location: string;
    comments: string;
}

export interface PersistedSession {
    inspectionID: string;
    form: SessionForm;
}

export function saveSession(session: PersistedSession): void {
    try {
        localStorage.setItem(KEY, JSON.stringify(session));
    } catch {
        // Storage unavailable (private mode / quota) — non-fatal, app still works.
    }
}

export function loadSession(): PersistedSession | null {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.inspectionID !== 'string' || !parsed.form) return null;
        return parsed as PersistedSession;
    } catch {
        return null;
    }
}

export function clearSession(): void {
    try {
        localStorage.removeItem(KEY);
    } catch {
        // ignore
    }
}
